
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import { _ as _objectSpread } from './_rollupPluginBabelHelpers-mixin.js';
import { VPopover } from 'v-tooltip';

const DEFAULT_POPOVER_SETTINGS = {
  'popover-class': [],
  'popover-base-class': ['pendo-popover'],
  'popover-wrapper-class': ['pendo-popover__wrapper'],
  'popover-inner-class': ['pendo-popover__inner'],
  'popover-arrow-class': ['pendo-popover__arrow'],
  'popper-options': {},
  'auto-height': true,
  'handle-resize': true,
  placement: 'right',
  trigger: 'hover',
  delay: 0,
  offset: 8
};
var script = {
  name: 'PendoPopover',
  components: {
    VPopover
  },
  inheritAttrs: false,
  props: {
    theme: {
      type: String,
      default: 'light',
      validator: theme => ['light', 'dark'].includes(theme)
    },
    arrow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    popoverAttrs() {
      const popoverProps = _objectSpread({}, this.$attrs);

      Object.keys(DEFAULT_POPOVER_SETTINGS).forEach(prop => {
        if (!popoverProps[prop]) {
          popoverProps[prop] = DEFAULT_POPOVER_SETTINGS[prop];
        } else {
          popoverProps[prop] = Array.isArray(DEFAULT_POPOVER_SETTINGS[prop]) ? [...DEFAULT_POPOVER_SETTINGS[prop], popoverProps[prop]] : popoverProps[prop];
        }
      });
      return popoverProps;
    }

  },

  created() {
    DEFAULT_POPOVER_SETTINGS['popover-class'] = [].concat(`pendo-popover--${this.theme}`, ...(this.arrow ? ['has-popover-arrow'] : []));
  }

};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-popover', _vm._g(_vm._b({}, 'v-popover', _vm.popoverAttrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_vm._t("popover")], 2)], 2);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-popover.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoPopover = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoPopover;
